import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse, ResponseStatus, PayloadResponse } from '../models/response.model';
import { ResponseStateVerifyIdentity } from '../models/verify.model';
import { VerifyIdentity } from '../models/verifyIdentity.model';
@Injectable({
  providedIn: 'root'
})
export class VerifyIdentityService {

  constructor(private http: HttpClient) { }
  private lineServiceUrl: string = environment.endpointBackend + '/api/line';
  apiVeifyIndentity(body: VerifyIdentity): Observable<PayloadResponse<ResponseStateVerifyIdentity>> {
    // return new Observable(res => res.next(this.mock))
    return this.http.post<ApiResponse<ResponseStateVerifyIdentity>>(this.lineServiceUrl + '/verify/identity', body).pipe(
      map(
        response => {
          return response.payload;
          // let result: PayloadResponse<ResponseStateVerifyIdentity>;
          // if (response.response_code === ResponseStatus.SUCCESS) {
          //   result = response.payload;
          //   return result;
          // }
          // result = response.payload;
          // result.data = null;
          // return result;
        }
      )
    )
  }
}
